<nz-result nzStatus="404" nzTitle="404" nzSubTitle="Desculpe, esta página não existe">
  <div nz-result-extra>
    <button nz-button nzType="primary" routerLink="..">Voltar para início</button>
  </div>
</nz-result>
